import { render, staticRenderFns } from "./NewsBlock.vue?vue&type=template&id=2a4d0787&scoped=true"
import script from "./NewsBlock.vue?vue&type=script&lang=js"
export * from "./NewsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4d0787",
  null
  
)

export default component.exports